import RentalPortalViewingApplicantPreviewModal from '../../RentalPortalViewingApplicantPreviewModal'

export function useRentalPortalViewingApplicantPreview({ setModal, onClose }) {
  function handleOpenApplicantPreview(viewing) {
    setModal(
      <RentalPortalViewingApplicantPreviewModal
        viewing={viewing}
        onClose={onClose}
      />
    )
  }

  return { handleOpenApplicantPreview }
}
